import { FC, useEffect } from 'react'

import { FieldProps as FormikFieldProps } from 'formik'
import { AnyObjectSchema } from 'yup'

import { TextField, TextFieldProps } from '@themenu/design-system'

import { isRequiredField } from '../../utils/isRequiredField'

export type FormikFieldInputProps = TextFieldProps &
  FormikFieldProps & { validationSchema?: AnyObjectSchema } & { forceValidation: boolean }

export const FormikFieldInput: FC<FormikFieldInputProps> = ({ form, field, validationSchema, ...props }) => {
  const isRequired = validationSchema ? isRequiredField({ validationSchema, fieldName: field.name }) : props.required

  useEffect(() => {
    form.validateForm()
  }, [props?.forceValidation]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <TextField
      size={56}
      required={isRequired}
      error={form?.touched[field.name] !== undefined && form?.errors[field.name] !== undefined}
      errorMessage={(form?.errors[field.name] as string) || ''}
      {...field}
      {...props}
      id={field.name}
    />
  )
}
